function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDel16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("g", {
  style: {
    opacity: 0.7
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z",
  "data-name": "Rectangle 118",
  style: {
    fill: "transparent"
  }
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Union 16",
  style: {
    fill: "none"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 4.5.5 8 0 7.5 3.5 4 0 .5.5 0 4 3.5 7.5 0l.5.5L4.5 4 8 7.5l-.5.5z",
  style: {
    stroke: "none"
  },
  transform: "translate(4 4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7.501 8-3.5-3.5L.5 8 0 7.5 3.5 4 0 .5.5 0 4 3.5 7.501 0 8 .5 4.5 4 8 7.501z",
  style: {
    fill: "#9d9d9d",
    stroke: "none"
  },
  transform: "translate(4 4)"
}))));
export default SvgIconDel16;